import React from 'react';
import Frame from '../../../../../../shared/components/Frame';
import Wrapper from '../../../../../../shared/components/Wrapper';
import ClosedReport from './components/ClosedReport';

function UnifiedReport() {
  return (
    <>
      <Frame.Default isActive width="100%">
        <Wrapper.Default isActive width="100%">
          <ClosedReport />
        </Wrapper.Default>
      </Frame.Default>
    </>
  );
}

export default UnifiedReport;
